export const ROUTES = {
  root: "/",
  forgot_password: "/forgot-password",
  reset_password: "/reset-password",
  update_password: "/profile/account-settings/update-password",
  profile: "/profile",
  personal_info: "/profile/personal-info",
  edit_personal_info: "/profile/personal-info/edit",
  certificates: "/profile/certificates",
  organization_info: "/settings/organization-info",
  edit_organization_info: "/profile/organization-info/edit",
  notifications: "/notifications",
  settings: "/settings",
  verify_email: "/verify-email",
  signup: "/signup",
  training: "/training",
  reflection: "/reflection",
  teaching: "/teaching",
  community: "/community",
  foundations_training: "/training/foundations-training",
  legacy_self_guided_training: "/training/self-guided-training",
  professional_certification: "/training/professional-certification",
  live_training: "/training/live-training",
  live_training_details: "/training/live-training-details/:cohortId",
  student_curriculum: "/teaching/student-curriculum",
  micropractices: "/teaching/micropractices",
  micropractice_detail: "/teaching/micropractices/:slug",
  media_player: "/training/media-player/:pillarId/:lessonId",
  account_settings: "/profile/account-settings",
  manage_users: "/settings/manage-users",
  manage_family_members: "/settings/manage-family-members",
  personal_reflection: "/reflection/personal",
  school_reflection: "/reflection/school",
  personal_reflection_archive: "/reflection/personal/archive",
  school_reflection_archive: "/reflection/school/archive",
  redirect_page: "/redirect-page/verify-email",
  core_tools_posters: "/coretoolposters",
  core_tools_posters_global: "/coretoolposters/global",
  core_tools_posters_africa: "/coretoolposters/africa",
  page_not_found: "*",
};
